export const IAAS_API_VERSION = "v1";
export const AUTH_API_VERSION = "v1";
